import React from 'react';
import { Popover, Icon, Tag } from 'antd';
const flagOptions = {
  UK: '🇬🇧',
  DE: '🇩🇪',
  FR: '🇫🇷',
  ES: '🇲🇽',
  JP: '🇯🇵',
  CN: '🇨🇳',
  IT: '🇮🇹',
  CA: '🇨🇦',
  US: '🇺🇸'
};

const ChannelLabel = ({ channel }) => {
  const { slug } = channel;
  const [_, marketplace, country] = slug.split('_');
  return (
    <Tag color="geekblue">
      {marketplace[0]}
      {country &&
        flagOptions[country] && (
          <span>
            &nbsp;
            {flagOptions[country]}
          </span>
        )}
    </Tag>
  );
};

export default class extends React.Component {
  render() {
    const { value, channels } = this.props;
    const listedChannels = channels.filter(
      channel => value && value.indexOf(channel.id) > -1
    );

    return (
      <Popover
        content={
          <ul>
            {channels.map(channel => (
              <li key={channel.id}>
                {value.indexOf(channel.id) > -1 ? (
                  <Icon
                    type="check-circle"
                    theme="twoTone"
                    twoToneColor="#52c41a"
                  />
                ) : (
                  <Icon
                    type="close-circle"
                    theme="twoTone"
                    twoToneColor="#aaa"
                  />
                )}
                &nbsp;
                {channel.name}
              </li>
            ))}
          </ul>
        }
        trigger="click"
      >
        {(!value.length || value.length > 5) && (
          <a>{value.length ? `Listed (${value.length})` : 'Not Listed'}</a>
        )}
        {value.length > 0 &&
          value.length <= 5 &&
          listedChannels.map(channel => (
            <ChannelLabel key={channel.id} channel={channel} />
          ))}
      </Popover>
    );
  }
}
